import * as FaIcons from 'react-icons/fa';
import * as AiIcons from 'react-icons/ai';

export const SidebarData = [
  {
    title: 'Home',
    path: '/',
    icon: <AiIcons.AiFillHome />,
    cName: 'nav-text'
  },
  {
    title: 'Felhasználó hozzáadása',
    path: '/sign-up',
    icon: <FaIcons.FaUser />,
    cName: 'nav-text'
  },
  {
    title: 'Event Manager',
    path: '/event-manager',
    icon: <FaIcons.FaCalendar />,
    cName: 'nav-text'
  },
  {
    title: 'Ùj event hozzádadása',
    path: '/event-manager/new',
    icon: <FaIcons.FaCalendarAlt />,
    cName: 'nav-text'
  },
];